var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPescado = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7999 7.0766C8.3999 7.0766 4.1999 11.3838 4.1999 11.3838L2.3999 12.6163L4.1999 13.938C6.6155 15.704 9.6107 18.1524 13.7999 18.1524C17.9999 18.1524 23.9999 13.8451 23.9999 11.9992C23.9999 10.1532 17.9999 7.0766 13.7999 7.0766Z",
    fill: "#00BCD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5433 7.42853C15.9379 8.81177 15.6001 10.3839 15.6001 11.9991C15.6001 13.9786 16.1533 15.8886 17.0401 17.497C20.1283 16.4024 24.0001 13.7423 24.0001 11.9991C24.0001 10.2559 19.8001 8.14353 16.5433 7.42853Z",
    fill: "#4DD0E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5999 11.9991C19.2626 11.9991 19.7999 11.4481 19.7999 10.7684C19.7999 10.0888 19.2626 9.53778 18.5999 9.53778C17.9372 9.53778 17.3999 10.0888 17.3999 10.7684C17.3999 11.4481 17.9372 11.9991 18.5999 11.9991Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 11.3838C18.9314 11.3838 19.2 11.1084 19.2 10.7685C19.2 10.4287 18.9314 10.1532 18.6 10.1532C18.2686 10.1532 18 10.4287 18 10.7685C18 11.1084 18.2686 11.3838 18.6 11.3838Z",
    fill: "#0277BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8001 7.07661C14.6617 7.07661 15.5983 7.20768 16.5433 7.42858C16.4881 7.12645 16.0831 5.08728 15.0001 4C13.5373 4.07692 8.1295 6.12286 6.6001 7.69194C6.9505 8.23096 7.1899 8.6543 7.3657 8.99888C9.0547 8.00452 11.2945 7.07661 13.8001 7.07661Z",
    fill: "#006064"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.69202C0.6 8.30734 1.2 11.1834 1.2 12.6146C1.2 14.0378 0.6 16.9218 0 17.5372C1.8 16.9218 3.72 14.911 4.1814 13.9246C4.1874 13.9295 4.194 13.9345 4.2 13.9381L3 12.6164L4.2 11.3839C4.2 11.3839 3 8.92266 0 7.69202Z",
    fill: "#006064"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1254 19.975C12.6528 20.0716 12.2094 19.8697 11.3064 19.6894C11.8728 18.5689 15.1782 15.4203 15.7824 15.7403L15.729 16.0301C16.3326 16.3507 15.6912 18.8538 15.1254 19.975Z",
    fill: "#006064"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5999 11.9992C15.5999 10.384 15.9377 8.81183 16.5431 7.42859C16.1039 7.3123 15.3641 7.20892 15.3641 7.20892C14.7311 8.73799 14.3999 10.3458 14.3999 11.9992C14.3999 14.0334 14.8883 16.0665 15.8339 17.8589C16.2215 17.7487 16.6619 17.6546 17.0405 17.4965C16.1531 15.8886 15.5999 13.9787 15.5999 11.9992Z",
    fill: "#0097A7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPescado, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Pescado.bd8845cc.svg";
export { ForwardRef as ReactComponent };